import React, { useState } from "react";
import AddButton from "../../../../partials/Buttons/AddButton";
import EditButton from "../../../../partials/Buttons/EditButton";
import NewGP from "../../../GP/NewGP";
import { useMutation } from "react-apollo";
import { UPDATE_PATIENT_GP } from "../../../../queries/patient.query";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import LoadingSpinner from "../../../../partials/loading";
import UpdateGP from "../../../GP/UpdateGP";
import { sendNotification } from "../../../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../../../event/model";
import { EventEmitter } from "../../../../event/EventEmitter";

const PatientGPInformation = ({ item, isAdmin, id }) => {
    const [update, setUpdate] = useState(false);
    const [_item, setItem] = useState(item);

    const [UpdateGPFunc, { loading }] = useMutation(UPDATE_PATIENT_GP, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.UpdatePatientGP) {
                const { message, doc } = d.UpdatePatientGP;
                // setItem(doc.gp);
                EventEmitter.subscribe(EVENT_TARGET.GP, (event) => setItem(event));
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.PATIENT);
                toast.success(message);
                setUpdate(false);
            }
        },
    });

    return (
        <div className="card">
            <div className="card-head">
                <header>GP Information</header>
            </div>
            <div className="card-body min-card">
                <LoadingSpinner loading={loading} bar={true} />
                {!update ? (
                    <table className="table table-bordered fade-in">
                        <tbody>
                            {_item && (
                                <React.Fragment>
                                    <tr>
                                        <td style={{ backgroundColor: "aliceblue" }}>
                                            <strong>Name</strong>
                                        </td>
                                        <td>{_item.name}</td>
                                    </tr>

                                    <tr>
                                        <td style={{ backgroundColor: "aliceblue" }}>
                                            <strong>Address</strong>
                                        </td>
                                        <td>{_item.address}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ backgroundColor: "aliceblue" }}>
                                            <strong>Email Address</strong>
                                        </td>
                                        <td>{_item.email}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ backgroundColor: "aliceblue" }}>
                                            <strong>Phone Number</strong>
                                        </td>
                                        <td>{_item.mobile}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ backgroundColor: "aliceblue" }}>
                                            <strong>Post Code</strong>
                                        </td>
                                        <td>{_item.post_code}</td>
                                    </tr>
                                </React.Fragment>
                            )}
                            {!_item && (
                                <tr className="fade-in">
                                    <td rowSpan="2">
                                        <div className="text-center">
                                            <p>No GP is Added Yet!</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                ) : (
                    <>
                        {_item ? (
                            <UpdateGP
                                item={_item}
                                onCancel={() => setUpdate(false)}
                                onSubmit={async (model) => {
                                    if (id) await UpdateGPFunc({ variables: { model, id } });
                                }}
                            />
                        ) : (
                            <NewGP
                                onCancel={() => setUpdate(false)}
                                onSubmit={async (model) => {
                                    if (id) await UpdateGPFunc({ variables: { model, id } });
                                }}
                            />
                        )}
                    </>
                )}
            </div>
            {isAdmin && !update && !_item && (
                <div className="card-footer text-right fade-in">
                    <AddButton onClick={() => setUpdate(true)} />
                </div>
            )}
            {isAdmin && !update && _item && (
                <div className="card-footer text-right fade-in">
                    <EditButton onClick={() => setUpdate(true)} />
                </div>
            )}
        </div>
    );
};

export default PatientGPInformation;
